export default __webpack_public_path__ + "static/media/person.57100032.svg";